// eslint-disable-next-line import/prefer-default-export
export const mapKeyValue = (value: any, mapKey: Function, mapValue: Function): object => {
  const obj: any = {};
  Object.keys(value).forEach(key => {
    obj[mapKey(value[key], key)] = mapValue(value[key], key);
  });

  return obj;
}
